<template>
  <profile-main>
    <profile-header activeMenu="profile" slot="profileNavigation" />
    <form class="form-horizontal" method="post" @submit.prevent="doUpdate">
      <div class="text-danger alert alert-danger" v-if="error && error.message">
        <small>{{error.message}}</small>
      </div>
      <div class="form-group">
        <div class="col-md-12">
          <input-text
              type="password"
              name="oldPassword"
              :value="form.oldPassword"
              :label="$t('Old Password')"
              :required="true"
              @input="text => { setField({ key: 'oldPassword', value: text }) }"
          />
        </div>
      </div>

      <div class="form-group">
        <div class="col-md-12">
          <input-text
            type="password"
            name="password"
            :value="form.password"
            :required="true"
            :label="$t('Password')"
            @input="text => { setField({ key: 'password', value: text }) }"
          />
        </div>
      </div>

      <div class="form-group">
        <div class="col-md-12">
          <input-text
            type="password"
            name="passwordRepeat"
            :value="form.passwordRepeat"
            :required="true"
            :label="$t('Repeat Password')"
            @input="text => { setField({ key: 'passwordRepeat', value: text }) }"
          />
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-12">
          <form-button
            type="info"
            inputType="submit"
            :text="$t('UPDATE')"
            :disabled="loading"
            :loading="loading"
            :block="true"
            :click="() => {}"
          />
        </div>
      </div>
    </form>
  </profile-main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import InputText from "@/components/Form/InputText";
import FormButton from "@/components/Form/FormButton";
import AlertBox from '@/components/Misc/AlertBox';

import ProfileHeader from './components/Header';
import ProfileMain from './components/Main';

export default {
  name: "Profile",
  components: {
    InputText,
    FormButton,
    AlertBox,
    ProfileHeader,
    ProfileMain
  },
  computed: {
    ...mapGetters({
      form: "auth/form",
      user: "auth/user",
      loading: "auth/loading",
      error: 'auth/error'
    }),
    currentUser() {
      return this.user || {};
    }
  },
  methods: {
    ...mapActions({
      setField: 'auth/setField',
      updateUserPassword: 'auth/updateUserPassword'
    }),
    async doUpdate() {
      await this.updateUserPassword();
    },
  }
};
</script>
